import { Page } from "../Page/Page";
import { createContentStyles, ThemeClasses } from "../../../theme/useContentStyles";
import { ReactNode } from "react";

const useStyles = createContentStyles();

export type ThemedPageProps = {
  children: ((classes: ThemeClasses) => ReactNode | undefined) | ReactNode | undefined
}

export const ThemedPage = (props: ThemedPageProps) => {
  const { children } = props;

  const { classes } = useStyles();

  return (
    <Page>
      {children instanceof Function ? children(classes) : children}
    </Page>
  );
};
